import type { FC } from "react";
import { useForm } from "@tanstack/react-form";

import { usePatchPatient } from "@/api/patients";
import Edit from "@/assets/icons/edit";
import { FieldSelect } from "@/components/form";
import type { UpdateModalProps } from "@/components/modals/administrative-infos-update-modal";
import GenericModal from "@/components/modals/generic-modal";
import { patchDiseaseSchema } from "@/schemas/patient";
import { resetForm } from "@/utils/form";
import { diseaseOptions } from "@/utils/patient";

const DiseaseUpdateModal: FC<UpdateModalProps> = ({
  open,
  setOpen,
  patient,
}) => {
  const { mutate } = usePatchPatient(patient.id);

  const { disease } = patient;

  const { Field, handleSubmit } = useForm({
    defaultValues: {
      disease,
    },
    onSubmit: async ({ value, formApi }) => {
      const values = patchDiseaseSchema.parse(value);
      mutate(value, {
        onSuccess: () => {
          setOpen(false);
          resetForm(values, formApi);
        },
      });
    },
  });

  return (
    <GenericModal
      title="Modifier les informations"
      logo={<Edit className="w-6 h-6" color="black" />}
      open={open}
      setOpen={() => setOpen(false)}
      handleSubmit={handleSubmit}
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-4 w-full px-6">
        <FieldSelect
          Field={Field}
          schema={patchDiseaseSchema}
          options={diseaseOptions}
          name="disease"
          label="Maladie"
        />
        <input type="submit" className="hidden" />
      </form>
    </GenericModal>
  );
};

export default DiseaseUpdateModal;
